import { ChangeEvent, useState } from "react";
import { TechDocSearchInputs } from "../../pages/support/TechDocPage";
import { SelectOption } from "../types/selectOption";
import { useQuery } from "@tanstack/react-query";
import { request } from "../../common/api";
import {
  GET_MACHINERY_SELECT_OPTIONS,
  GET_TECH_DOC_SELECT_OPTIONS,
} from "../query-keys";

const useTechDocSearchInputData = (
  searchDefaultValues: TechDocSearchInputs
) => {
  const [search, setSearch] =
    useState<TechDocSearchInputs>(searchDefaultValues);

  // 문서유형 options 조회
  const { data: documentTypeSelectOptions } = useQuery<SelectOption[]>({
    queryKey: [GET_TECH_DOC_SELECT_OPTIONS, "all"],
    queryFn: async () => {
      return await request<SelectOption[]>({
        method: "GET",
        url: "/select/options/techDoc",
      });
    },
  });

  // 장비 options 조회
  const { data: machinerySelectOptions } = useQuery<SelectOption[]>({
    queryKey: [GET_MACHINERY_SELECT_OPTIONS, search.shipNo],
    queryFn: async () => {
      if (!search.shipNo) {
        return [];
      }

      return await request<SelectOption[]>({
        method: "GET",
        url: `/equipment-info/machinery/select/options/${search.shipNo}`,
      });
    },
  });

  // 문서유형 선택 변경
  const handleDocumentTypeSelectChange = (
    e: ChangeEvent<HTMLSelectElement>
  ) => {
    setSearch({
      ...search,
      dcmTypeName: e.target.value,
    });
  };

  // 장비 선택 변경
  const handleMcySelectChange = (e: ChangeEvent<HTMLSelectElement>) => {
    setSearch({
      ...search,
      mcyName: e.target.options[e.target.selectedIndex].text,
      ssrMachine: e.target.value,
    });
  };

  // 날짜 변경
  const handleDateChange = (e: ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;

    setSearch({
      ...search,
      [name]: value,
    });
  };

  return {
    search,

    /** 문서 유형 select options */
    documentTypeSelectOptions,

    /** 장비 select options */
    machinerySelectOptions,

    /** 문서유형 선택 변경 */
    handleDocumentTypeSelectChange,

    /** 장비 선택 변경 */
    handleMcySelectChange,

    /** 날짜 변경*/
    handleDateChange,
  };
};

export default useTechDocSearchInputData;
